import { Navigate, Route, Routes } from 'react-router-dom';

import { Thread } from './Thread';
import { Threads } from './Threads';

export const ThreadsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Threads />} />
      <Route path=":id" element={<Thread />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
